import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { useSession } from 'next-auth/react';
import { ShopTypes } from '~/lib/data-contract';
import useUserProfile from '~/services/shop/hooks/mit-fog/useUserProfile';
import { getAccountStatement } from '../../operations/mit-fog';

export default function useAccountStatement() {
    const { data } = useSession();
    const { data: profile } = useUserProfile();
    const token = data?.accessToken ?? null;
    const customerId = profile?.customer?.id ?? null;

    return useQuery<ShopTypes.IAccountStatement[], HTTPError>(
        ['account-statement', { customerId, token }],
        ({ signal }) =>
            getAccountStatement({
                customerId,
                token,
                signal,
            }),
        {
            enabled: Boolean(data?.accessToken) && Boolean(customerId),
        },
    );
}
